<template>
    <Dialog v-model:open="opened">
        <DialogContent
            :with-close-button="false"
            :close-on-click-outside="false"
            class="sm:max-w-[300px]"
        >
            <div class="flex items-center space-x-2 text-xs">
                <LoaderIcon class="w-4 h-4 animate-spin" />
                <span>{{ message }}</span>
            </div>
        </DialogContent>
    </Dialog>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useLoadingStore } from '@/stores/loading'
import { LoaderIcon } from 'lucide-vue-next'
import { Dialog, DialogContent } from '@/components/ui/dialog'

const store = useLoadingStore()
const { opened, message } = storeToRefs(store)
</script>
